import { Resource } from '../../../Resource/Types';

export interface GroupSuggestion {
  id: number;
  name: string;
}

export interface GroupSuggestions {
  query: string;
  suggestions: GroupSuggestion[];
}

export type GroupSuggestionsResource = Resource<GroupSuggestions>;

export interface UserGroup {
  id: number;
  name: string;
  organization?: string;
  memberCount?: number;
  assignedLicenseCount?: number;
  assignedLicenseIds?: number[];
}

export interface UnselectedUserGroup {
  kind: 'unselected';
}

export interface SelectedUserGroup {
  kind: 'selected';
  group: UserGroup;
}

export interface NewUserGroup {
  kind: 'new';
  name: string;
}

export type SelectableUserGroup = UnselectedUserGroup | SelectedUserGroup | NewUserGroup;

export const createUnselectedGroup = (): UnselectedUserGroup => ({ kind: 'unselected' });

export const createSelectedGroup = (group: UserGroup): SelectedUserGroup => ({
  kind: 'selected',
  group,
});

export const createNewGroup = (name: string): NewUserGroup => ({
  kind: 'new',
  name,
});
